import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class BackgroundAnimate {
    constructor(el) {
        this.el = el;
        this.setVars();
        this.init();
    }

    setVars() {
        this.activeCls = "s-active";
        this.inactiveCls = "hidden";
        this.slides = this.el.querySelectorAll("img");
        this.active = this.el.querySelectorAll(`.${this.activeCls}`);
        this.topCls = "z-10";
        this.next = this.active.nextSibling;
        this.duration = 15;
        this.endScale = 1.15;
    }

    init() {
        this.animateZoom(0);
    }


    handleNext(index) {
        let next = index + 1;
        if (next > this.slides.length - 1) {
            this.animateZoom(0);
        }
        this.animateZoom(next);
    }

    animateZoom(index) {
        let slide = this.slides[index];
        gsap.set(slide, { opacity: 1, scale: 1 });
        slide.classList.add(this.activeCls);
        slide.classList.remove(this.inactiveCls);
        const tl = gsap.timeline();
        tl.fromTo(
            slide,
            {
                scale: 1,
            },
            {
                scale: this.endScale,
                duration: this.duration,
            },
        ).to(
            slide,
            {
                opacity: 0,
                duration: 1.5,
                onStart: () => {
                    slide.classList.add(this.topCls);
                    this.handleNext(index);
                },
                onComplete: () => {
                    slide.classList.remove(this.topCls);
                },
            },
            "-=1",
        );
    }
}
